import { getDataTestId } from "./getDataTestId";

export const getInputTestIdByName = (name?: string) => {
  return getDataTestId("field", name);
};
